module.exports = __webpack_public_path__ + "static/media/ico_sort_down.7c61a11f.svg";